import React from 'react';
import { connect } from 'react-redux';
import { ContentGroup } from 'ui';
import * as topicsSelectors from 'selectors/learn/topics';
import LearnTopicCard from '../../shared/LearnTopicCard';

const Topics = ({ topics }) => (
  <ContentGroup
    className="LearnContentGroup"
    title={t('content.groups.topics')}
    items={topics}
  >
    <ContentGroup.Items
      render={topic => <LearnTopicCard key={topic.id} {...topic} />}
    />
  </ContentGroup>
);

const mapStateToProps = state => ({
  topics: topicsSelectors.allTopics(state),
});

export default connect(mapStateToProps)(Topics);
